
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type GetApiCourses200ContentItemSectionsItemLecturesItemPlatformSupport = typeof GetApiCourses200ContentItemSectionsItemLecturesItemPlatformSupport[keyof typeof GetApiCourses200ContentItemSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCourses200ContentItemSectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
